/**
 * SmartPhoneLink Component
 * Desktop → navigates to /contact
 * Mobile → initiates phone call (tel:)
 * 
 * Usage:
 * <SmartPhoneLink className="..." onClick={optionalTracker}>
 *   04 71 08 27 09
 * </SmartPhoneLink>
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { isMobileDevice } from '../utils/device';

const PHONE_NUMBER = '0471082709';
const PHONE_DISPLAY = '04 71 08 27 09';

export const SmartPhoneLink = ({ 
  children, 
  className = '', 
  onClick,
  phoneNumber = PHONE_NUMBER,
  ...props 
}) => {
  const handleClick = (e) => {
    if (onClick) onClick(e);
  };

  if (isMobileDevice()) {
    return (
      <a 
        href={`tel:${phoneNumber}`} 
        className={className}
        onClick={handleClick}
        {...props}
      >
        {children || PHONE_DISPLAY}
      </a>
    );
  }

  return (
    <Link 
      to="/contact" 
      className={className}
      onClick={handleClick}
      {...props}
    >
      {children || PHONE_DISPLAY}
    </Link>
  );
};

export default SmartPhoneLink;
